import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import {
    Sizes,
    PageBehaviourButton,
    AnimatedFadeContainer,
    IconPlus,
    IconMinus,
} from '@ratehub/base-ui';


function ExpandableWithButton({ buttonDescriptor, children, ...otherProps }) {
    const [ isExpanded, setIsShowingMore ] = useState(false);

    return (
        <div
            {...otherProps}
        >
            <AnimatedFadeContainer
                isVisible={isExpanded}
            >
                {children}
            </AnimatedFadeContainer>

            <PageBehaviourButton
                className="show-more-info"
                data-name="show-more-info"
                size="small"
                iconLocation="left"
                iconComponent={isExpanded ? IconMinus : IconPlus}
                message={(
                    <FormattedMessage
                        {...buttonDescriptor}
                        values={{ isExpanded: isExpanded }}
                    />
                )}
                onClick={() => setIsShowingMore(!isExpanded)}
            />
        </div>
    );
}

ExpandableWithButton.propTypes = {
    buttonDescriptor: PropTypes.shape({
        id: PropTypes.string.isRequired,
        description: PropTypes.string,
        defaultMessage: PropTypes.string,
    }).isRequired,
    children: PropTypes.node.isRequired,
};


export default styled(ExpandableWithButton)`
    padding-bottom: ${Sizes.SPACING.TWO};
`;
